<template>
    <div :class="isMobile==0?'':'Projectsde_mobile'" class="Projectsde">
        <div :class="isMobile==0?'':'Projectsde_box_mobile'" class="Projectsde_box">
            <!-- 标题：添加动画类 -->
            <div :class="isMobile==0?'':'Projectsde_big_title_mobile'" class="Projectsde_big_title animate-fade-in" v-html="pro.translations.title.content" style="margin-bottom: 20px;"></div>
            <!-- <div class="Projectsde_big_title animate-fade-in" v-html="pro.translations.subtitle.content" style="margin-bottom: 20px;"></div> -->
            <img  :class="isMobile==0?'':'projectsde_img_mobile'"
                class="projectsde_img animate-fade-in" 
                :src="'https://app.choisiyachts.com' + item"
                v-for="(item, index) in getImgeList(pro?.images[0]?.image_url || '')" 
                :key="index"
                :style="{ animationDelay: `${0.6 + index * 0.3}s` }"
            />
            
            <!-- 正文：添加动画类 -->
            <div class="projectsde_content animate-fade-in" v-html="pro.translations.content.content"> </div>
        </div>
        <bottom-text></bottom-text>
    </div>
</template>

<script>
// 脚本部分保持不变
import { newDetail } from '../../request/api.js'
import bottomText from './bottomText.vue';
export default {
    components: {
        bottomText
    },
    name: 'Projects',
    data() {
        return {
            lang: {},
            proId: this.getUrlKey('id'),
            pro: null,
            isMobile: 0
        }
    },
    watch: {
        lang: {
            handler(newLang, oldLang) {
                console.log('Lang 变化了：', newLang);
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.isMobile=localStorage.getItem('isMobile')
        this.lang = JSON.parse(localStorage.getItem('Lang'))
        if (this.lang.fyType == 2) {
            this.getNew('en')
        } else {
            this.getNew('zh')
        }
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage();
        });
    },
    created() {
    },
    methods: {
        getUrlKey(name) {
            console.log(this.$route.params.id)
            return this.$route.params.id
        },
        getImgeList(string) {
            return string ? string.split(',') : []
        },
        syncLangFromStorage() {
            this.lang = JSON.parse(localStorage.getItem('Lang'))
            console.log(this.lang)
            if (this.lang.fyType == 2) {
                this.getNew('en')
            } else {
                this.getNew('zh')
            }
        },
        getNew(language) {
            let data = {
                id: this.proId,
                language
            }
            newDetail(data).then(res => {
                this.pro = res.data
            })
        }
    }
}
</script>

<style>
/* 原有样式保持不变 */
.Projectsde {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
.Projectsde_mobile{
    height: 88%;
}
.Projectsde_box {
    display: flex;
    flex-direction: column;
    width: 71%;
    margin: 60px auto;
}
.Projectsde_box_mobile{
    margin: 20px auto;
    width: 94%;
}
.Projectsde_big_title {
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 28px;
    color: #021131;
    text-align: left;
    font-style: normal;
    /* text-transform: none;
    word-wrap: break-word;
    overflow-wrap: break-word; */
}
.Projectsde_big_title_mobile{
    font-size: 24px;
}
.projectsde_img {
    width: 1400px;
    height: 779px;
    border-radius: 0px 0px 0px 0px;
    margin: 10px auto;
}
.projectsde_img_mobile{
    border: 1px solid;
    width: 100%;
    height: 250px;
}
.projectsde_content {letter-spacing:1px ;
    margin-top: 10px;
    font-family: Arial, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #021131;
    line-height: 25px;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

/* 添加浮现动画样式 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    opacity: 0;
    animation: fadeIn 0.8s ease-out forwards;
}

/* 设置阶梯式延迟 */
.Projectsde_big_title {
    animation-delay: 0s; /* 标题最先显示 */
}

.projectsde_content {
    animation-delay: 1s; /* 正文最后显示，确保在所有图片之后 */
}
</style>